import Urls from "./url";
import { User } from "../models/data";
import { createMedia } from "./media_service";

// Helper function to retrieve the user from localStorage
const getUser = (): User | null => {
    const value = localStorage.getItem('user');
    return value ? JSON.parse(value) : null;
};

// Reusable headers constants
const defaultHeaders = {
    'Content-Type': 'application/json',
};

const getAuthHeaders = (token: string) => ({
    ...defaultHeaders,
    'Authorization': `Bearer ${token}`,
});

// Helper function for handling fetch requests and responses
const handleFetch = async (url: string, options = {}) => {
    try {
        const response = await fetch(url, options);
        const message = await response.json();
        return response.ok ? { message, error: null } : { message: null, error: response.statusText };
    } catch (error: any) {
        console.log(error.message)
        return { message: null, error: error.message };
    }
};

// Fetch operations
export const fetchUserFundraisers = (id: any) => handleFetch(Urls('userfundraiserUrl',id));
export const fetchAllFundraisers = () => handleFetch(Urls('allFundraiserUrl'));
export const fetchSingleFundraiser = (id: string) => handleFetch(Urls('singleFundraiserUrl',id));
export const fetchOrgRelatedFundraisers = (id: string) => handleFetch(Urls('orgFundraiserUrl',id));

// Create and edit fundraisers
export const createFundraiser = async (data: any) => {
    const user = getUser();
    if (!user) return { message: null, error: 'No user found' };

    await createMedia(data.file).then((m) => (data.acf.image = m?.message));

    const createResponse = await handleFetch(Urls('createFundraiserUrl'), {
        method: 'POST',
        headers: getAuthHeaders(user.token!),
        body: JSON.stringify({ title: data.title }),
    });

    if (createResponse.message) {
        const { id } = createResponse.message;
        return updateFundraiser(data, id);
    }

    return createResponse;
};

export const editFundraiser = async (data: any, id: any) => {
    const user = getUser();
    if (!user) return { message: null, error: 'No user found' };

    if (data.file) {
        await createMedia(data.file).then((m) => (data.acf.image = m?.message));
    }

    return updateFundraiser(data, id);
};

// Update operations
export const updateFundraiser = async (data: any, id: any) => {
    const user = getUser();
    if (!user) return { message: null, error: 'No user found' };

    const body = {
        title: data.title,
        status: data.status,
        acf: data.acf,
    };

    return handleFetch(Urls('updatFundraiserUrl', id), {
        method: 'POST',
        headers: getAuthHeaders(user.token!),
        body: JSON.stringify(body),
    });
};

// Create and update credits
export const createCredit = async (data: any) => {
    const user = getUser();
    if (!user) return { message: null, error: 'No user found' };

    const createResponse = await handleFetch(Urls('createCreditUrl'), {
        method: 'POST',
        headers: getAuthHeaders(user.token!),
        body: JSON.stringify({ title: data.title }),
    });

    if (createResponse.message) {
        const { id } = createResponse.message;
        return updateCredit(data, id);
    }

    return createResponse;
};

export const updateCredit = async (data: any, id: any) => {
    const user = getUser();
    if (!user) return { message: null, error: 'No user found' };

    const body = {
        status: data.status,
        acf: data.acf,
    };

    return handleFetch(Urls('updateCreditUrl', id), {
        method: 'POST',
        headers: getAuthHeaders(user.token!),
        body: JSON.stringify(body),
    });
};

// Fetch fundraiser progress
export const fetchFundraiserProgress = async (id: any) => {
    const body = { id };

    return handleFetch(Urls('fundraiserProgressUrl'), {
        method: 'POST',
        headers: defaultHeaders,
        body: JSON.stringify(body),
    });
};

export default {};
